import React from 'react';
import type { FC } from 'react';
import styles from './HostMono.module.scss';

const PALETTE: ReadonlyArray<[bg: string, fg: string]> = [
    ['#E6F1FB', '#0C447C'],
    ['#E1F5EE', '#085041'],
    ['#FAEEDA', '#633806'],
    ['#EEEDFE', '#3C3489'],
    ['#FBEAF0', '#72243E'],
    ['#FAECE7', '#712B13'],
];

const hashOf = (text: string): number => {
    let hash = 0;
    for (let i = 0; i < text.length; i += 1) hash = (hash * 31 + text.charCodeAt(i)) | 0;
    return Math.abs(hash);
};

interface HostMonoProps {
    host: string;
}

export const HostMono: FC<HostMonoProps> = ({ host }) => {
    const [bg, fg] = PALETTE[hashOf(host) % PALETTE.length];
    const letter = host.charAt(0).toUpperCase() || '?';

    return (
        <span className={styles.mono} style={{ background: bg, color: fg }} aria-hidden>
            {letter}
        </span>
    );
};